import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import {
    StatusRound,
    StatusRoundDescription,
    useSeasonOptions,
} from "../../../api";
import {
    FormButton,
    SeasonContext,
    SelectOption,
    Subtitle,
} from "../../componentes";
import { Grid } from "@material-ui/core";
import CustomSelect from "../../componentes/Form/SelectFieldFormik/CustomSelect";

export interface RaceControlAfterRaceFilterState {
    seasonId: string;
    status: string;
}

interface RaceControlAfterRaceFilterProps {
    onFilter: (filter: RaceControlAfterRaceFilterState) => void;
}

const RaceControlAfterRaceFilter: React.FC<RaceControlAfterRaceFilterProps> = ({
    onFilter,
}) => {
    const currentSeason = useContext(SeasonContext);
    const seasonOptions = useSeasonOptions();
    const [filter, setFilter] = useState<RaceControlAfterRaceFilterState>({
        seasonId: currentSeason.id,
        status: StatusRound.IN_PROGRESS,
    });
    const applyFilter = useCallback(() => onFilter(filter), [filter, onFilter]);
    const statusOptions = useMemo<SelectOption[]>(
        () => [
            {
                label: StatusRoundDescription.CREATED,
                value: StatusRound.CREATED,
            },
            {
                label: StatusRoundDescription.IN_PROGRESS,
                value: StatusRound.IN_PROGRESS,
            },
            { label: StatusRoundDescription.DONE, value: StatusRound.DONE },
        ],
        []
    );
    useEffect(() => {
        if (filter.seasonId || !currentSeason) return;

        setFilter((oldValue) => ({
            ...oldValue,
            seasonId: currentSeason.id,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSeason]);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Subtitle text="Filtros" color="textSecondary" />
            </Grid>
            <Grid item sm={6} xs={12}>
                <CustomSelect
                    label="Temporada"
                    options={seasonOptions}
                    onChange={(v) =>
                        setFilter((oldValue) => ({
                            ...oldValue,
                            seasonId: v.target.value,
                        }))
                    }
                    value={filter.seasonId}
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <CustomSelect
                    label="Status da etapa"
                    options={statusOptions}
                    onChange={(v) =>
                        setFilter((oldValue) => ({
                            ...oldValue,
                            status: v.target.value,
                        }))
                    }
                    value={filter.status}
                />
            </Grid>
            <Grid item xs={12} direction="row-reverse" container>
                <FormButton onClick={applyFilter} color="primary">
                    Filtrar
                </FormButton>
            </Grid>
        </Grid>
    );
};

export { RaceControlAfterRaceFilter };
